import styled from 'styled-components';

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
FlexColumn.displayName = 'FlexColumn';

export default FlexColumn;
